module.exports = __webpack_public_path__ + "static/media/7.528a469e.jpg";